import { render } from "./EditFloorComponent.vue?vue&type=template&id=a2188d8c&scoped=true"
import script from "./EditFloorComponent.vue?vue&type=script&lang=js"
export * from "./EditFloorComponent.vue?vue&type=script&lang=js"

import "./EditFloorComponent.vue?vue&type=style&index=0&id=a2188d8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2188d8c"]])

export default __exports__